/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Button,
  Table,
  Modal,
  FormGroup,
  Form,
  ControlLabel,
  FormControl,
  Col,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ShowIf from 'loracoms/ShowIf';
import ControlTips from 'loracoms/ControlTips';
import { getTokenList, deleteToken, addtoken } from 'loraapi/token';
import TableList from './TableList';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
};

class AccountCenter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lists: [],
      showDeleteModal: false,
      deleteObj: { id: '', name: '' },
      showAddTokenModal: false,
      newToken: '',
      editName: false,
      showAnimation: false,
      addErr: false,
      deleteErr: false,
      addEmpty: false,
    };

    this.intlMsg = new IntlMsg(props.intl, 'accountcenter.manageview');
    this.handleDeleteModal = this.handleDeleteModal.bind(this);
    this.handleDeleteToken = this.handleDeleteToken.bind(this);
    this.handleNewTokenChange = this.handleNewTokenChange.bind(this);
    this.handleAddToken = this.handleAddToken.bind(this);
    this.handleEditName = this.handleEditName.bind(this);
  }

  componentWillMount() {
    this.loadTokenList();
  }
  loadTokenList() {
    getTokenList({ pageSize: 100 })
      .then((res) => {
        const lists = _.sortBy(res.list, l => l.createdAt).reverse();
        this.setState({ lists });
      })
      .catch(() => {});
  }
  handleDeleteModal(id, name) {
    this.setState({ showDeleteModal: true, deleteErr: false, deleteObj: { id, name } });
  }
  handleDeleteToken() {
    const { deleteObj: { id }, lists } = this.state;
    deleteToken(id)
      .then(() => {
        const newLists = _.filter(lists, list => list.token !== id);
        this.setState({ lists: newLists, showDeleteModal: false });
      })
      .catch((err) => {
        const code = err.code === 'GENERALERROR' ? 'GENERALERROR' : 'COMMONERR';
        this.setState({ deleteErr: code });
      });
  }
  handleNewTokenChange(e) {
    const newToken = e.target.value;
    this.setState({ newToken });
    if (_.trim(newToken).length !== 0) {
      this.setState({ addEmpty: false });
    }
  }
  handleAddToken() {
    const { newToken, lists } = this.state;
    if (_.trim(newToken).length !== 0) {
      addtoken(newToken)
        .then((res) => {
          lists.unshift(res);
          this.setState({ newToken: '', showAddTokenModal: false, lists, showAnimation: true });
          _.delay(() => {
            this.setState({ showAnimation: false });
          }, 500);
        })
        .catch(() => {
          this.setState({ addErr: true });
        });
    } else {
      this.setState({ addEmpty: true });
      this.tokenInput.focus();
    }
  }
  handleEditName() {
    this.setState({ editName: true });
  }
  render() {
    const { lists,
      showDeleteModal,
      deleteObj,
      showAddTokenModal,
      newToken,
      showAnimation,
      addErr,
      deleteErr,
      addEmpty,
    } = this.state;
    const content = lists.map((list, index) => (
      <TableList
        key={list.token}
        list={list}
        index={index}
        showAnimation={showAnimation}
        onHandleDelete={this.handleDeleteModal}
      />
    ));
    return (
      <div className={styles.tokenContainer}>
        <div className={styles.mTL}>
          <span className={styles.mRL}>
            {this.intlMsg.msg('title.token')}
          </span>
          <span>
            <Button
              bsStyle="aisz-success"
              onClick={() => this.setState({
                showAddTokenModal: true,
                addErr: false,
                addEmpty: false,
              })}
            >
              Token&nbsp;<i className="fa fa-plus" />
            </Button>
          </span>
        </div>
        <Table className="aisz-table-light" striped hover bordered responsive>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('tablecolumn.name')}</th>
              <th>Token</th>
              <th>{this.intlMsg.msg('tablecolumn.createtime')}</th>
              <th>{this.intlMsg.msg('tablecolumn.operation')}</th>
            </tr>
          </thead>
          <tbody>
            {content}
          </tbody>
        </Table>
        <Modal
          bsClass="aisz-modal-danger"
          show={showDeleteModal}
          onHide={() => this.setState({ showDeleteModal: false })}
        >
          <Modal.Header closeButton>
            <div className="text-center">
              <i className="fa fa-exclamation-triangle" aria-hidden="true" />
              &nbsp;{this.intlMsg.msg('deletetip.deletetoken')}
            </div>
          </Modal.Header>
          <Modal.Body>
            <ShowIf if={deleteErr === false}>
              <div className="text-center">
                <p>
                  {this.intlMsg.msg('deletetip.confirmdelete')}&nbsp;
                  <strong>
                    {deleteObj.name}({deleteObj.id})
                  </strong> ?
                </p>
                <div>
                  <Button
                    bsStyle="aisz-warning"
                    onClick={() => this.setState({ showDeleteModal: false })}
                  >
                    <i className="fa fa-repeat" aria-hidden="true" />&nbsp;
                    {this.intlMsg.msg('cancel', 'lora.button')}
                  </Button>&nbsp;
                  <Button
                    bsStyle="aisz-danger"
                    onClick={this.handleDeleteToken}
                  >
                    <i className="fa fa-trash-o" aria-hidden="true" />&nbsp;
                    {this.intlMsg.msg('confirm', 'lora.button')}
                  </Button>
                </div>
              </div>
            </ShowIf>
            <ShowIf if={deleteErr === 'GENERALERROR'}>
              <p className="text-danger text-center">{this.intlMsg.msg('deletetokentip')}</p>
            </ShowIf>
            <ShowIf if={deleteErr === 'COMMONERR'}>
              <p className="text-danger text-center">{this.intlMsg.msg('deletetokentipcommon')}</p>
            </ShowIf>
          </Modal.Body>
        </Modal>
        <Modal
          bsClass="aisz-modal-light"
          backdrop="static"
          show={showAddTokenModal}
          onHide={() => this.setState({ showAddTokenModal: false })}
        >
          <Modal.Header closeButton>
            {this.intlMsg.msg('addmodaltip')}
          </Modal.Header>
          <Modal.Body>
            <ShowIf if={!addErr}>
              <Form horizontal>
                <FormGroup >
                  <Col md={3}>
                    <ControlLabel bsClass="aisz-control-label">
                      {this.intlMsg.msg('label.name')}&nbsp;*
                    </ControlLabel>
                  </Col>
                  <Col md={6}>
                    <FormControl
                      value={newToken}
                      bsClass="aisz-form-control-f"
                      placeholder={this.intlMsg.msg('placeholder.token.name')}
                      onChange={this.handleNewTokenChange}
                      inputRef={(ref) => { this.tokenInput = ref; }}
                    />
                    <ControlTips
                      show={addEmpty}
                      message={this.intlMsg.msg('E.FE_EMPTY')}
                      azStyle="danger"
                      placement="right"
                    />
                  </Col>
                </FormGroup>
                <FormGroup >
                  <Col md={6} mdOffset={3}>
                    <Button
                      bsStyle="aisz-primary"
                      className={styles.fullWidth}
                      onClick={this.handleAddToken}
                    >
                      {this.intlMsg.msg('button.createtoken')}
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            </ShowIf>
            <ShowIf if={addErr}>
              <p className="text-danger text-center">{this.intlMsg.msg('modaltitle')}</p>
            </ShowIf>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

AccountCenter.propTypes = propTypes;

export default injectIntl(AccountCenter);




// WEBPACK FOOTER //
// ./src/containers/AccountCenter/coms/ManageView/index.jsx